import { graphql } from "gatsby";
import React, { useEffect } from "react";
import { useNationalDogSurveyContext } from "../../../NationalDogSurvey/NationalDogSurvey.context";
import { Button } from "../../../components/common";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphNationalDogSurveyCtaProps {
	linkTitle: string;
	htmlText?: string;
}

export const getParagraphNationalDogSurveyCtaProps = ({
	field_cta_title,
	field_nds_description,
}: Queries.ParagraphNationalDogSurveyCtaDataFragment): ParagraphNationalDogSurveyCtaProps => ({
	linkTitle: field_cta_title,
	htmlText: field_nds_description?.value,
});
export const ParagraphNationalDogSurveyCta: React.FC<
	ParagraphNationalDogSurveyCtaProps
> = ({ linkTitle, htmlText }) => {
	const { surveyState, onLoadWarmRoute, onLoadSupporterId, setFormData } =
		useNationalDogSurveyContext();

	useEffect(() => {
		const loadWarmData = async (
			utmMediumParam: string,
			utmSourceParam: string,
		) => {
			const warmData: NDS.WarmUserData = await fetch(
				`${process.env.GATSBY_NDS_WARM_DATA_BASE_URL}/${supporterId}.json`,
			)
				.then((response) => response.json())
				.catch(() => null);

			if (warmData)
				onLoadWarmRoute(
					{ ...warmData, supporterId },
					utmMediumParam,
					utmSourceParam,
				);
			else if (supporterId !== surveyState.supporterId) {
				onLoadSupporterId(supporterId);
			}
		};

		const urlParams = new URLSearchParams(window.location.search);

		const supporterId = urlParams.get("supporterid");
		const utmSourceParam = urlParams.get("utm_source");
		const utmMediumParam = urlParams.get("utm_medium");

		if (surveyState.warmData?.supporterId === supporterId) {
			return;
		}
		if (surveyState.supporterId === supporterId) {
			return;
		}

		if (supporterId) {
			loadWarmData(utmMediumParam, utmSourceParam);
		} else {
			setFormData((prev) => ({
				...prev,
				utmMediumParam,
				utmSource: utmSourceParam,
			}));
		}
	}, [
		surveyState.supporterId,
		surveyState.warmData?.supporterId,
		onLoadWarmRoute,
		onLoadSupporterId,
		setFormData,
	]);

	return (
		<WrappedSection sectionName="ParagraphNationalDogSurveyCta">
			{htmlText && (
				<div
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
			)}
			<Button
				url="/about-us/what-we-do/national-dog-survey/take-part"
				variant={"primary"}
			>
				{linkTitle}
			</Button>
		</WrappedSection>
	);
};

export default ParagraphNationalDogSurveyCta;

export const fragment = graphql`
    fragment ParagraphNationalDogSurveyCtaData on paragraph__national_dog_survey_cta {
        __typename
        id
        field_cta_title
        field_nds_description {
            value
        }
    }
`;
